export default [
    {
        path: '/callstatistics/callcustomer',
        meta: {
            // authCode: "xcrm.callcustomer.mylist"
        },
        component: (resolve) => require(['./CallCustomer.vue'], resolve),
    },
    {
        path: '/callstatistics/record',
        meta: {
            // authCode: "xcrm.callcustomer.list"
        },
        component: (resolve) => require(['./CallContactRecord.vue'], resolve),
    },
    {
        path: '/callstatistics/work',
        meta: {
            // authCode: "xcrm.callcustomer.list"
        },
        component: (resolve) => require(['./CallWork.vue'], resolve),
    },
    {
        path: '/callstatistics/phonerecord/:type',
        meta: {
            // authCode: "xcrm.callcustomer.list"
        },
        component: (resolve) => require(['./CallPhoneRecord.vue'], resolve),
    }
]



// WEBPACK FOOTER //
// ./src/modules/callStatistics/router.js